import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    Container,
    ContainerJoinRequestList,
    ContainerType,
} from '../../../shared/models/container.types';
import { ContainerService } from '../../../shared/services/container/container.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import {
    ContainerSettingsDialogData,
    SettingsComponent,
} from '../../../shared/components/container-administration/container-settings/settings.component';
import {
    ContainerMembersComponent,
    ContainerMembersDialogData,
} from '../../../shared/components/container-administration/container-members/container-members.component';

@Component({
    selector: 'app-project-split-screen-header',
    templateUrl: './project-split-screen-header.component.html',
    styleUrls: ['./project-split-screen-header.component.scss'],
    standalone: false,
})
export class ProjectSplitScreenHeaderComponent implements OnInit {
    protected readonly ContainerType = ContainerType;

    @Input() container: Container;
    @Input() isOwner: boolean;

    hoverFunctionalButtonIdx: Number = null;
    joinRequests: ContainerJoinRequestList;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private containerService: ContainerService,
        private dialog: MatDialog
    ) {}

    ngOnInit(): void {
        if (this.isOwner) {
            this.containerService
                .getOpenJoinRequestsForContainer(this.container.id)
                .subscribe((requestsList: ContainerJoinRequestList) => {
                    this.joinRequests = requestsList;
                });
        }
    }

    areRequestsExisting() {
        return this.joinRequests?.values?.length > 0;
    }

    openMembers() {
        const dialogConfig = new MatDialogConfig<ContainerMembersDialogData>();
        dialogConfig.data = {
            container: this.container,
            joinRequests: this.joinRequests,
        };
        dialogConfig.autoFocus = false;

        this.dialog
            .open(ContainerMembersComponent, dialogConfig)
            .afterClosed()
            .subscribe();
    }

    openSettings() {
        const dialogConfig = new MatDialogConfig<ContainerSettingsDialogData>();
        dialogConfig.data = { container: this.container };
        dialogConfig.autoFocus = false;

        this.dialog
            .open(SettingsComponent, dialogConfig)
            .afterClosed()
            .subscribe();
    }
}
